import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import { useEffect, useState } from 'react'

interface Props {
  isOpen: boolean
  handleClose: () => void
  initialDepth?: string
  initialDrillSize?: string
  initialPileNo?: string
  initialGridLine?: string
  initialLocation?: string
  isSaving?: boolean
  onSave: (
    depth: string,
    drillSize: string,
    pileNo: string,
    gridLine: string,
    location: string
  ) => void | Promise<void>
}

const PreboreSettingModal: React.FC<Props> = ({
  isOpen,
  handleClose,
  initialDepth = '',
  initialDrillSize = '',
  initialPileNo = '',
  initialGridLine = '',
  initialLocation = '',
  isSaving = false,
  onSave,
}) => {
  const modalsRoot = document.getElementById('root-modals') || document.body
  const [depth, setDepth] = useState<string>('')
  const [drillSize, setDrillSize] = useState<string>('')
  const [pileNo, setPileNo] = useState<string>('')
  const [gridLine, setGridLine] = useState<string>('')
  const [location, setLocation] = useState<string>('')

  useEffect(() => {
    if (isOpen) {
      setDepth(initialDepth)
      setDrillSize(initialDrillSize)
      setPileNo(initialPileNo)
      setGridLine(initialGridLine)
      setLocation(initialLocation)
    }
  }, [isOpen, initialDepth, initialDrillSize, initialPileNo, initialGridLine, initialLocation])

  const handleSave = () => {
    onSave(depth, drillSize, pileNo, gridLine, location)
  }

  const handleCloseModal = () => {
    if (isSaving) return
    setDepth('')
    setDrillSize('')
    setPileNo('')
    setGridLine('')
    setLocation('')
    handleClose()
  }

  return createPortal(
    <Modal
      id='kt_modal_prebore_setting'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={isOpen}
      onHide={handleCloseModal}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>ตั้งค่า prebore</h2>
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleCloseModal}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-100px'>
          <div className='mb-5'>
            <label htmlFor='prebore-depth' className='form-label'>
              ความลึก (เมตร)
            </label>
            <input
              id='prebore-depth'
              type='number'
              className='form-control form-control-sm'
              value={depth}
              disabled={isSaving}
              onChange={e => setDepth(e.target.value)}
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='prebore-drill-size' className='form-label'>
              ขนาดสว่าน (ม.ม.)
            </label>
            <input
              id='prebore-drill-size'
              type='number'
              className='form-control form-control-sm'
              value={drillSize}
              disabled={isSaving}
              onChange={e => setDrillSize(e.target.value)}
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='prebore-pile-no' className='form-label'>
              Pile No.
            </label>
            <input
              id='prebore-pile-no'
              type='text'
              className='form-control form-control-sm'
              value={pileNo}
              disabled={isSaving}
              onChange={e => setPileNo(e.target.value)}
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='prebore-grid-line' className='form-label'>
              Grid Line
            </label>
            <input
              id='prebore-grid-line'
              type='text'
              className='form-control form-control-sm'
              value={gridLine}
              disabled={isSaving}
              onChange={e => setGridLine(e.target.value)}
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='prebore-location' className='form-label'>
              ชื่อผังทำงาน
            </label>
            <input
              id='prebore-location'
              type='text'
              className='form-control form-control-sm'
              value={location}
              disabled={isSaving}
              onChange={e => setLocation(e.target.value)}
            />
          </div>
        </div>

        <div className='modal-footer'>
          <button className='btn btn-light fw-bold' onClick={handleCloseModal} disabled={isSaving}>
            ยกเลิก
          </button>
          <button className='btn btn-primary fw-bold' onClick={handleSave} disabled={isSaving}>
            บันทึก
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default PreboreSettingModal
